import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AmcGuard implements CanActivateChild {
    private readonly renewalRoutes = ['/dashboard', '/store'];

    constructor(
        private authService: AuthService,
        private router: Router,
    ) {}

    canActivateChild(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        const path = state.url.split('?')[0];
        if (_route.queryParamMap.get('history') === '1'
            && (path === '/storage-locations' || path === '/production' || path.startsWith('/production/'))) return true;
        if (!this.isAccessRestricted() || this.isRenewalRoute(state.url)) {
            return true;
        }

        return this.router.createUrlTree(['/dashboard'], {
            queryParams: { renew: true },
        });
    }

    private isRenewalRoute(rawUrl: string): boolean {
        const path = String(rawUrl || '').split('?')[0].split('#')[0];
        return this.renewalRoutes.some(route => path === route || path.startsWith(`${route}/`));
    }

    private isAccessRestricted(): boolean {
        const dairy = this.authService.getCurrentDairy();
        if (!dairy) return false;
        const plan = String(dairy?.plan_soft || 'BASIC').toUpperCase();
        if (plan === 'BASIC' || plan === 'STARTER') return true;
        if (this.hasActiveGrace(dairy?.access_grace_until)) return false;
        const status = String(dairy?.subscription_status || 'ACTIVE').toUpperCase();
        const rawExpiry = dairy?.amc_date || dairy?.expiry_date;
        if (status !== 'ACTIVE' || !rawExpiry) return true;

        const expiry = new Date(rawExpiry);
        if (Number.isNaN(expiry.getTime())) return false;

        if (/^\d{4}-\d{2}-\d{2}$/.test(String(rawExpiry).trim())) {
            expiry.setHours(23, 59, 59, 999);
        }
        return expiry.getTime() < Date.now();
    }

    private hasActiveGrace(rawGraceUntil: unknown): boolean {
        const value = String(rawGraceUntil || '').trim();
        if (!value) return false;
        const graceUntil = new Date(value);
        if (Number.isNaN(graceUntil.getTime())) return false;
        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) graceUntil.setHours(23, 59, 59, 999);
        return graceUntil.getTime() >= Date.now();
    }
}
